/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { STYLED_SELECT_CLASS, STYLED_SELECT_STYLE } from '../../utils/styledSelect';

function SelectTimezoneBox({ id, currentTimezone, saveTimezone, timezoneOptions, open, onToggle }) {
  const [selectedTimezone, setSelectedTimezone] = useState(currentTimezone);

  useEffect(() => { setSelectedTimezone(currentTimezone); }, [currentTimezone]);

  return (
    <div className="relative inline-flex items-center gap-2">
      <p className="text-xs text-ink-700 truncate" style={{ margin: 0, maxWidth: 160 }}>
        {selectedTimezone || 'Workspace Default'}
      </p>
      <button
        type="button"
        onClick={onToggle}
        className={`inline-flex items-center box-border px-2.5 py-1 rounded-[6px] text-xs font-medium border bg-white transition flex-shrink-0 ${open ? 'text-[#CC4525] border-[#f3cfc6] hover:bg-[#fdf6f4]' : 'text-ink-900 border-rule hover:border-brand-500 hover:text-brand-700'}`}
        style={{ borderStyle: 'solid' }}
      >
        {open ? 'Cancel' : 'Edit'}
      </button>
      {open && (
        <div
          className="absolute z-10 bg-white rounded-[12px] border border-rule"
          style={{ top: 38, left: 0, width: 312, padding: 16, borderStyle: 'solid', boxShadow: '0 8px 24px rgba(14, 30, 64, 0.12)' }}
        >
          <span className="block text-xs text-ink-500 mb-1">Select Timezone</span>
          <select
            value={selectedTimezone || ''}
            onChange={(e) => setSelectedTimezone(e.target.value)}
            className={`${STYLED_SELECT_CLASS} w-full`}
            style={STYLED_SELECT_STYLE}
          >
            <option value="">Select timezone</option>
            {timezoneOptions.map((tz) => <option key={tz} value={tz}>{tz}</option>)}
          </select>
          <button
            type="button"
            onClick={() => { onToggle(); saveTimezone({ timezone: selectedTimezone, memberId: id }); }}
            disabled={!selectedTimezone}
            className="inline-flex items-center justify-center box-border h-10 w-full px-4 mt-3 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition"
          >
            Save
          </button>
        </div>
      )}
    </div>
  );
}

SelectTimezoneBox.propTypes = {
  id: PropTypes.number.isRequired,
  currentTimezone: PropTypes.string,
  saveTimezone: PropTypes.func.isRequired,
  timezoneOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  open: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

SelectTimezoneBox.defaultProps = { currentTimezone: '', open: false };

export default SelectTimezoneBox;
